import React from 'react'
import styles from './GreenWall.module.css'
import Grid2 from '../Grid/grid2'
import { BannerStool } from '../Banner/BannerStool'
import { BannerWoodenCollection } from '~/components/Banner/BannerWoodenCollection'

export const Stool: React.FC = () => {
  return (
    <div className={styles.page}>
      {/* HERO */}
      <BannerWoodenCollection
        href="/cdn/stool/landing.png"
        content={BannerStool}
      ></BannerWoodenCollection>

      <section>
        <Grid2
          images={[
            { src: '/cdn/stool/1.png' },
            { src: '/cdn/stool/landing.png' },
            { src: '/cdn/stool/3.png' },
            { src: '/cdn/stool/4.png' },
            { src: '/cdn/stool/5.png' },
          ]}
          href="/"
        ></Grid2>
      </section>
    </div>
  )
}
